export default [
  {
    path: '/error',
    name: 'error',
    goesToMenu: false,
    component: () => import('@/layout/maintemplate/MainTemplate.vue'),
    children: [
      {
        path: 'accessdenied',
        name: 'accessdenied',
        component: () => import('@/views/auth/AccessDenied.vue')
      }
    ]
  }
];
